import { GetGroupTopEXP as GetGroupTopEXPAction } from "../../providers/supabase-provider/actions/GetGroupTopEXP";
import type { GetGroupTopEXPPayload, ITopEXP } from "../../entities";

export const GetGroupTopEXP = async (payload: GetGroupTopEXPPayload): Promise<ITopEXP[]> => {
  return GetGroupTopEXPAction(payload);
};
